import { RESERVED } from './reserved';
import { AUTH_CODES } from './codes/auth';
import { EMAIL_ACCOUNTS_CODES } from './codes/email-accounts';
import { DWD_WORKSPACE_CODES } from './codes/dwd-workspace';
import { WARMUP_CODES } from './codes/warmup';
import { BILLING_CODES } from './codes/billing';
import { SETTINGS_CODES } from './codes/settings';
import { PROFILE_CODES } from './codes/profile';
import { REPORTS_CODES } from './codes/reports';
import { ONBOARDING_CODES } from './codes/onboarding';
import { NOTIFICATIONS_CODES } from './codes/notifications';
import { AI_CODES } from './codes/ai';
import { ANALYTICS_CODES } from './codes/analytics';
import { HEALTH_CODES } from './codes/health';
import { TAGS_CODES } from './codes/tags';
import { PREFERENCES_CODES } from './codes/preferences';
import { API_CODES } from './codes/api';
import { ADMIN_CODES } from './codes/admin';
import { INBOUND_WEBHOOKS_CODES } from './codes/inbound-webhooks';
import { TEMPLATE_LIBRARY_CODES } from './codes/template-library';
import { AUDIT_LOGS_CODES } from './codes/audit-logs';
import { SALESHANDY_CODES } from './codes/saleshandy';
import { APUS_CODES } from './codes/apus';
import { INTERNAL_BACKFILL_CODES } from './codes/internal-backfill';
import { ORG_PURGE_CODES } from './codes/org-purge';

/**
 * The namespaced error-code accessor. Reference codes by name everywhere —
 * `ErrorCode.EmailAccounts.TestSmtp.SmtpFailed` — never by string literal.
 * Each feature's accessor is authored in `src/codes/<feature>.ts`.
 */
export const ErrorCode = {
  Reserved: {
    Unhandled: RESERVED.UNHANDLED,
    Validation: RESERVED.VALIDATION,
  },
  Auth: AUTH_CODES,
  EmailAccounts: EMAIL_ACCOUNTS_CODES,
  DwdWorkspace: DWD_WORKSPACE_CODES,
  Warmup: WARMUP_CODES,
  Billing: BILLING_CODES,
  Settings: SETTINGS_CODES,
  Profile: PROFILE_CODES,
  Reports: REPORTS_CODES,
  Onboarding: ONBOARDING_CODES,
  Notifications: NOTIFICATIONS_CODES,
  Ai: AI_CODES,
  Analytics: ANALYTICS_CODES,
  Health: HEALTH_CODES,
  Tags: TAGS_CODES,
  Preferences: PREFERENCES_CODES,
  Api: API_CODES,
  Admin: ADMIN_CODES,
  InboundWebhooks: INBOUND_WEBHOOKS_CODES,
  TemplateLibrary: TEMPLATE_LIBRARY_CODES,
  AuditLogs: AUDIT_LOGS_CODES,
  Saleshandy: SALESHANDY_CODES,
  Apus: APUS_CODES,
  InternalBackfill: INTERNAL_BACKFILL_CODES,
  OrgPurge: ORG_PURGE_CODES,
} as const;
